import React, { useState, useEffect } from "react";
import axios from "axios";
import { Modal, Button, Table, Form } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Testimonials = () => {
    const [testimonials, setTestimonials] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState("add");
    const [formData, setFormData] = useState({ title: "", role: "", desc: "", image: "", id: null });

    useEffect(() => {
        fetchTestimonials();
    }, []);

    const fetchTestimonials = () => {
        axios
            .get("https://api.glyphqai.com/api/get-testimonals")
            .then((response) => {
                if (response.data.status === 200) {
                    setTestimonials(response.data.testimonals);
                }
            })
            .catch((error) => console.error("Error fetching testimonials:", error));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleOpenModal = (type, testimonial = null) => {
        setModalType(type);
        if (type === "edit" && testimonial) {
            setFormData({
                title: testimonial.title,
                role: testimonial.role,
                desc: testimonial.desc,
                image: testimonial.image,
                id: testimonial.id
            });
        } else {
            setFormData({ title: "", role: "", desc: "", image: "", id: null });
        }
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const formPayload = new FormData();
        formPayload.append("title", formData.title);
        formPayload.append("role", formData.role);
        formPayload.append("desc", formData.desc);
        formPayload.append("image", formData.image);

        if (modalType === "add") {

            axios
                .post("https://api.glyphqai.com/api/store-testimonals", formPayload, {
                    headers: { "Content-Type": "multipart/form-data" },
                })
                .then(() => {
                    toast.success("Testimonial added successfully!");
                    fetchTestimonials();
                    handleCloseModal();
                })
                .catch((error) => {
                    console.error("Error storing testimonial:", error);
                    toast.error("Failed to add testimonial.");
                });
        } else if (modalType === "edit") {
            formPayload.append("_method", "PUT")

            axios
                .post(
                    `https://api.glyphqai.com/api/update-testimonals/${formData.id}`,
                    formPayload,

                )
                .then(() => {
                    toast.success("Testimonial updated successfully!");
                    fetchTestimonials();
                    handleCloseModal();
                })
                .catch((error) => {
                    console.error("Error updating testimonial:", error);
                    toast.error("Failed to update testimonial.");
                });
        }
    };

    const handleDelete = (id) => {
        axios
            .delete(`https://api.glyphqai.com/api/deletetestimonals/${id}`)
            .then(() => {
                setTestimonials(testimonials.filter((testimonial) => testimonial.id !== id));
                toast.success("Testimonial deleted successfully!");
            })
            .catch((error) => {
                console.error("Error deleting testimonial:", error);
                toast.error("Failed to delete testimonial.");
            });
    };

    return (
        <>
            <div className="container">
                <div className="my-3 mt-5 d-flex justify-content-between">
                    <h2 className="font-bold display-5">Testimonials</h2>
                    <Button
                        onClick={() => handleOpenModal("add")}
                        className="mb-3"
                    >
                        Add Testimonial
                    </Button>
                </div>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th className="text-center">#</th>
                            <th>Title</th>
                            <th>Role</th>
                            <th>Description</th>
                            <th>Images</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {testimonials.map((testimonial, index) => (
                            <tr key={testimonial.id}>
                                <td className="text-center">{index + 1}</td>
                                <td>{testimonial.title}</td>
                                <td>{testimonial.role}</td>
                                <td>{testimonial.desc}</td>
                                <td>
                                    <img src={`https://api.glyphqai.com/uploads/testimonals/${testimonial.image}`} alt={`${testimonial.title}  Testimonial`} />
                                </td>
                                <td>
                                    <Button
                                        onClick={() => handleOpenModal("edit", testimonial)}
                                    >
                                        Edit
                                    </Button>{" "}
                                    <Button
                                        variant="danger"
                                        onClick={() => handleDelete(testimonial.id)}
                                    >
                                        Delete
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

            {/* Modal for Add/Edit Testimonial */}
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {modalType === "add" ? "Add Testimonial" : "Edit Testimonial"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="formTitle" className="mt-0">
                            <Form.Label>Title</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter title"
                                name="title"
                                value={formData.title}
                                onChange={handleInputChange}
                                required
                            />
                        </Form.Group>
                        <Form.Group controlId="formRole">
                            <Form.Label>Role</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter role"
                                name="role"
                                value={formData.role}
                                onChange={handleInputChange}
                                required
                            />
                        </Form.Group>
                        <Form.Group controlId="formDesc">
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                placeholder="Enter description"
                                name="desc"
                                value={formData.desc}
                                onChange={handleInputChange}
                                required
                            />
                        </Form.Group>
                        {true &&
                            <Form.Group controlId="formFeatureImage">
                                <Form.Label>Feature Image</Form.Label>
                                <Form.Control
                                    type="file"
                                    name="image"
                                    onChange={(e) => setFormData({ ...formData, image: e.target.files[0] })}
                                />
                            </Form.Group>
                        }
                        <Button
                            type="submit"
                            className="mt-3"
                        >
                            {modalType === "add" ? "Add Testimonial" : "Update Testimonial"}
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>

            <ToastContainer />
        </>
    );
};

export default Testimonials;
